import axios from 'axios';

import { getApiEndPoint } from '../../../helpers/apibase';
import { mapServerError } from '../../../services/utils/serverErrorMapper';

const baseURL = getApiEndPoint();

const whitelabelApi = axios.create({
  baseURL: `${baseURL}/api/v1.0`,
  withCredentials: true,
});

export interface WhiteLabelAppStoreConfig {
  [key: string]: any;
}

export interface WhiteLabelPlayStoreConfig {
  [key: string]: any;
}

const getWhitelabelAppStoreConfig = async (appId: string): Promise<WhiteLabelAppStoreConfig> => {
  try {
    const response = await whitelabelApi.get(`/whitelabelconfig/${appId}/appstore`);
    return response.data.Data;
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const updateWhiteLabelAppStoreConfig = async (
  appId: string,
  config: WhiteLabelAppStoreConfig
): Promise<void> => {
  try {
    await whitelabelApi.post(`/whitelabelconfig/${appId}/appstore`, config);
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const getWhiteLabelPlayStoreConfig = async (appId: string): Promise<WhiteLabelPlayStoreConfig> => {
  try {
    const response = await whitelabelApi.get(`/whitelabelconfig/${appId}/playstore`);
    return response.data.Data;
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const updateWhiteLabelPlayStoreConfig = async (
  appId: string,
  config: WhiteLabelPlayStoreConfig
): Promise<void> => {
  try {
    await whitelabelApi.post(`/whitelabelconfig/${appId}/playstore`, config);
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

export const whitelabelService = {
  getWhitelabelAppStoreConfig,
  updateWhiteLabelAppStoreConfig,
  getWhiteLabelPlayStoreConfig,
  updateWhiteLabelPlayStoreConfig,
};
